import { createActivityStore, createSessionStore } from "@/app/activity/store"
import { useTranslation } from "react-i18next"

import "./sessionSelector.scss"
import { useEffect } from "react"
import SessionListItem from "@/app/activity/detail/sessionSelector/SessionListItem"
import { Session } from "@/types/session"
import BasicButton from "@/components/button/BasicButton"

export default function SessionSelector({
  sessionList,
  onSessionClick,
  onCopyClick,
}: {
  sessionList?: Session[]
  onSessionClick: (session: Session) => void
  onCopyClick?: (session: Session) => void
}) {
  const { t } = useTranslation()
  const { activity } = createActivityStore((state) => ({
    activity: state.tempActivity,
  }))

  const { setSessions, sessions, setUpsertDialogOpen, setSession, selectedSession } =
    createSessionStore((state) => ({
      setSessions: state.setSessions,
      sessions: state.sessions,
      setUpsertDialogOpen: state.setUpsertDialogOpen,
      setSession: state.setSession,
      selectedSession: state.session,
    }))

  // 세션 선택 상태에선 Add Session 비활성화 (선택 해제 후에만 새 세션 추가 가능)
  const isSessionSelected = !!selectedSession?.idfSession

  const handleAddSession = () => {
    setSession({
      dateStart: activity?.dateStart,
      dateFinish: activity?.dateFinish,
    } as Session)
    setUpsertDialogOpen(true)
  }

  useEffect(() => {
    if (sessionList) {
      const sorted = [...sessionList].sort((a, b) => {
        const startCompare = new Date(a.dateStart).getTime() - new Date(b.dateStart).getTime()
        if (startCompare !== 0) return startCompare
        return new Date(a.dateFinish).getTime() - new Date(b.dateFinish).getTime()
      })
      setSessions(sorted)
    }
  }, [sessionList])

  return (
    <div className="SessionSelectorCont">
      <div className="session-selector-header">
        <p className="session-selector-title">{t("session")}</p>
        <BasicButton
          type="primary-outlined"
          size="xs"
          onClick={handleAddSession}
          disabled={isSessionSelected}>
          {t("addSession")}
        </BasicButton>
      </div>
      {sessions?.length === 0 && <p className="no-data">{t("messages.noDataAvailable")}</p>}

      <div className="session-list">
        {sessions?.map((session: Session) => (
          <SessionListItem
            key={session.idfSession}
            session={session}
            onClick={onSessionClick}
            onCopyClick={onCopyClick}
          />
        ))}
      </div>
    </div>
  )
}
